// extracted by mini-css-extract-plugin
export default {"steps":"Er-z","header":"Fr-z","description":"Gr-z"};